import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { NgWtBreadcrumbModule } from '@ds/ng-wt-breadcrumb';
import { SafeUrlModule } from '../common/pipes/safe-url/safe-url.module';
import { SearchComponent } from '../modules/search/search.component';
import { SharedModule } from './../shared/shared.module';
import { TranslocoRootModule } from './../transloco/transloco-root.module';
import { LoginComponent } from './login/login.component';
import { throwIfAlreadyLoaded } from './module-import.guard';
import { ShellComponent } from './shell/shell.component';
import { LayoutModule } from '@ds/ng-wt-layout';
import { AppSettingModule } from '@ds/ng-wt-app-settings';
import { AboutComponent } from './about/about.component';
import { HttpRequestInterceptor } from './interceptor/http-request.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RegistrationModule } from '../staticUI/registration/registration.module';
import { ForgotPasswordComponent } from './login/components/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './login/components/change-password/change-password.component';
import { NewPlayerRegistrationComponent } from './login/components/new-player-registration/new-player-registration.component';
import { SignupComponent } from './login/components/signup/signup.component';
import { ConfirmationAlertDialogComponent } from 'src/app/core/login/components/confirmation-alert-dialog/confirmation-alert-dialog.component';
import { EmailConfirmationComponent } from './login/components/email-confirmation/email-confirmation.component';
import { VerifyDetailsComponent } from './login/components/verify-details/verify-details.component';
import { ResetPasswordComponent } from './login/components/reset-password/reset-password.component';
import { IdleTimeoutWarningDialogComponent } from './authentication/idle-timeout-warning-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    LayoutModule,
    NgWtBreadcrumbModule,
    MatSelectModule,
    MatCheckboxModule,
    MatInputModule,
    TranslocoRootModule,
    MatFormFieldModule,
    SafeUrlModule,
    AppSettingModule,
    RegistrationModule,
    MatMomentDateModule
  ],
  declarations: [
    LoginComponent,
    ShellComponent,
    SearchComponent,
    AboutComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    NewPlayerRegistrationComponent,
    SignupComponent,
    ConfirmationAlertDialogComponent,
    EmailConfirmationComponent,
    VerifyDetailsComponent,
    ResetPasswordComponent,
    IdleTimeoutWarningDialogComponent
  ],
  exports: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: ['MM/DD/YYYY', 'MMM DD,YYYY', 'MMM DD YYYY'],
        },
        display: {
          dateInput: 'MMM DD, YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    }
  ],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
